module.exports = __webpack_public_path__ + "static/182-e0abe67462f824077241dc2d6f1ec2e4.png";